import React, { useEffect, useState } from 'react'
import { list, getUserByCID, getBadgesByCID, setActiveInActive } from '../api/company';
import Loader from '../components/Loader';
import { updateUserData, } from '../api/user';
import { setCallBackURL } from "../api/company"
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function CallbackUrl() {
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [companyStatus, setCompanyStatus] = useState("");
    const [companyName, setCompanyName] = useState("0");
    const [badgeList, setBadgeList] = useState([]);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);
    const getCompanyList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            }))
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getUserList = async (companyName) => {
        if (companyName !== "0") {
            setLoading(true);
            let userData = await getBadgesByCID(companyName);
            setLoading(false);
            if (userData.status > 199 && userData.status <= 399) {
                const input = userData.data.data; // Replace with your actual data
                const output = [];
                const seen = new Set();
                input.forEach((item) => {
                    const badges = item.Badges;

                    for (const badgeMain in badges) {
                        const badgeData = badges[badgeMain];
                        if (badgeData.Badgeandtopic && Array.isArray(badgeData.Badgeandtopic)) {
                            badgeData.Badgeandtopic.forEach((entry) => {
                                const key = `${badgeMain}|${entry.Badge}|${entry.Topic[0] || ""}`;
                                if (!seen.has(key)) {
                                    seen.add(key);
                                    output.push({
                                        BadgeMain: badgeMain,
                                        Name: entry.Badge,
                                        Topic: entry.Topic[0] || ""
                                    });
                                }
                            });
                        }
                    }
                });
                setBadgeList(output);
            } else {
                setBadgeList([]);
            }
        } else {
            setBadgeList([]);
        }
    }
    const handleChange = async (e) => {
        const { value, } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const cStatus = selectedOption.getAttribute('cStatus');
        setCompanyStatus(cStatus);
        setCompanyName(value);
        getUserList(value);

    }



    const handleEditUser = async (obj) => {
        navigate(`/registration/${obj._id}/edit-user`)
    };

    const handleCallbackURL = async (obj) => {
        console.log(handleCallbackURL);
        const callbackurlResponse = await setCallBackURL(obj);
    }


    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Badge List</h4>
                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Badge </th>
                                            <th> Name </th>
                                            <th> Topic </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {badgeList.map((obj, index) => (
                                            <tr key={obj._id}>
                                                <td> {index + 1} </td>
                                                <td> {obj.BadgeMain} </td>
                                                <td> {obj.Name} </td>
                                                <td> {obj.Topic} </td>
                                                <td>
                                                    {obj.Name && obj.Topic ? (
                                                        <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleCallbackURL(obj)} className="btn btn-primary me-2" >Set Callback URL</button>
                                                    ) : (
                                                        <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleEditUser(obj)} className="btn btn-success me-2" >Update Badge</button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
